import React, { useEffect } from "react";
import { IDisplayState } from "../../interfaces/IDisplayState";
import { IsEcom } from "../../utilities/apiEndpointResolver";
import DigitalDataService from "../../utilities/digitalDataService";
import SessionCacheService from "../../utilities/sessionCacheService";
import UserService from "../../utilities/userService";
import "./wbmLogo.scss";

let _href: string;

function goHome() {
  window.location.href = _href;
}

export interface IWbmLogoProps {
  href: string;
  displayState: IDisplayState;
  isLoggedIn: boolean;
  customLogo?: string;
  isMobile?: boolean;
}

function WbmLogo(props: IWbmLogoProps) {
  useEffect(() => {
    _href = props.href;
  }, [props.href]);

  const svg = () => {
    return (
      <img
        src={props.displayState.logo}
        alt="W.B. Logo"
        className={`width-height-limit ${props.isMobile ? "d-block " : ""}`}
      />
    );
  };

  const onLogoClick = () => {
    if (!IsEcom()) {
      goHome();
    } else {
      const userConfigId = DigitalDataService.userConfigId();
      SessionCacheService.clear();

      if (userConfigId && props.isLoggedIn) {
        UserService.switchUserConfig(userConfigId).subscribe(goHome, goHome);
      } else {
        goHome();
      }
    }
  };

  return (
    <span
      onClick={UserService.displayUserInfo() ? onLogoClick : undefined}
      className="d-block"
      role="button"
    >
      {props.customLogo ? (
        <>
          <img
            className={`wbm-logo custom ${props.isMobile ? "mobile" : ""}`}
            src={props.customLogo}
            alt="W.B. Logo Custom"
          />
          {props.isMobile ? (
            <span className="mobile-custom-logo-powered-by">
              <span className="powered-by-divider"></span>
              <span className="powered-by-label">Powered By</span>
              <span className="powered-by-img">{svg()}</span>
            </span>
          ) : (
            <span className="desktop-powered-by">
              <span className="powered-by-label">Powered By</span>
              <span className="powered-by-img">{svg()}</span>
            </span>
          )}
        </>
      ) : (
        <span className={`wbm-logo ${props.isMobile ? "mobile" : ""}`}>
          {svg()}
        </span>
      )}
    </span>
  );
}

export default WbmLogo;
